import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { JJamesCardComponent } from 'shared-lib';
import { ParkingSpaceDto, InfrastructureDto, DeviceGroupDto } from '../../../api/gen';
import { CreateParkingSpaceInitialComponent } from './create-parking-space-initial/create-parking-space-initial.component';
import { CreateInfrastructureParkingSpaceComponent } from './create-infrastructure-parking-space/create-infrastructure-parking-space.component';
import { CreateDeviceGroupsParkingSpaceComponent } from './create-device-groups-parking-space/create-device-groups-parking-space.component';
import { CreateParkingSpaceFinalComponent } from './create-parking-space-final/create-parking-space-final.component';
import { firstValueFrom } from 'rxjs';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { InfrastructureService, ParkingSpaceService } from '../../../api/gen';

@Component({
    selector: 'app-create-parking-space',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        JJamesCardComponent,
        CreateParkingSpaceInitialComponent,
        CreateInfrastructureParkingSpaceComponent,
        CreateDeviceGroupsParkingSpaceComponent,
        CreateParkingSpaceFinalComponent,
        MatSnackBarModule
    ],
    templateUrl: './create-parking-space.component.html',
    styleUrls: ['./create-parking-space.component.scss']
})
export class CreateParkingSpaceComponent {
    currentStep = signal(0);
    createdParkingSpace = signal<ParkingSpaceDto | null>(null);
    createdInfrastructure = signal<InfrastructureDto | null>(null);
    createdDeviceGroups = signal<DeviceGroupDto[]>([]);

    constructor(
        private router: Router,
        private parkingSpaceService: ParkingSpaceService,
        private infrastructureService: InfrastructureService,
        private snackBar: MatSnackBar
    ) { }

    onParkingSpaceCreated(parkingSpace: ParkingSpaceDto): void {
        this.createdParkingSpace.set(parkingSpace);
        this.currentStep.set(1);
    }

    async onInfrastructureCreated(infrastructure: InfrastructureDto): Promise<void> {
        this.createdInfrastructure.set(infrastructure);
        const parkingSpaceId = this.createdParkingSpace()?.id;
        const infrastructureId = infrastructure.id;

        if (parkingSpaceId && infrastructureId) {
            try {
                await firstValueFrom(this.parkingSpaceService.parkingSpaceParkingSpaceIdInfrastructureInfrastructureIdPost(parkingSpaceId, infrastructureId));
                this.snackBar.open('Infrastructure successfully assigned to parking space.', 'Close', { duration: 3000 });
                this.currentStep.set(2);
            } catch (error) {
                console.error('Error assigning infrastructure to parking space:', error);
                this.snackBar.open('Failed to assign infrastructure to parking space.', 'Close', { duration: 5000 });
            }
        }
    }

    async onDeviceGroupsCreated(deviceGroups: DeviceGroupDto[]): Promise<void> {
        this.createdDeviceGroups.set(deviceGroups);
        const infrastructureId = this.createdInfrastructure()?.id;

        // if (infrastructureId && deviceGroups.length > 0) {
        //     try {
        //         for (const group of deviceGroups) {
        //             if (group.id) {
        //                 await firstValueFrom(this.infrastructureService.infrastructuresInfrastructureIdDeviceGroupsDeviceGroupIdPost(infrastructureId, group.id));
        //             }
        //         }
        //         this.snackBar.open('Device groups successfully assigned to infrastructure.', 'Close', { duration: 3000 });
        //     } catch (error) {
        //         console.error('Error assigning device groups to infrastructure:', error);
        //         this.snackBar.open('Failed to assign device groups to infrastructure.', 'Close', { duration: 5000 });
        //     }
        // }
        this.currentStep.set(3);
    }

    onFinish(): void {
        const parkingSpaceId = this.createdParkingSpace()?.id;
        if (parkingSpaceId) {
            this.router.navigate(['/parking-space', parkingSpaceId]);
        } else {
            this.router.navigate(['/parking-space']);
        }
    }

    goBack(): void {
        this.router.navigate(['/parking-space']);
    }
}
